import { preset } from "@rscollabs/vue-cli-plugin-vuetify-preset-capsule-wardrobe/preset";

export default preset;
